export default "__VITE_ASSET__t_LjMZj6__"